import { useMutation } from '@tanstack/react-query';
import { useKeycloak } from '@react-keycloak/web';

interface GenerateOutputSchemaFromFunctionResponse {
  schema: string;
}

export function useGenerateOutputSchemaFromFunction() {
  const { keycloak } = useKeycloak();

  return useMutation({
    mutationFn: async (
      agentUuid: string
    ): Promise<GenerateOutputSchemaFromFunctionResponse> => {
      const response = await fetch(
        `${
          import.meta.env.VITE_IMPORT_ENGINE_ENDPOINT
        }/api/v1/bundles/generate_bundle/functions/generate_output_schema_from_function`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${keycloak.token}`,
          },
          method: 'POST',
          body: JSON.stringify({ agentUuid }),
        }
      );

      const data = await response.json();

      return {
        schema: data?.data?.schema,
      };
    },
  });
}
